export const CLIENT_SET = 'CLIENT_SET'
export const CLIENT_UNSET = 'CLIENT_UNSET'
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
